import { gql, useQuery } from 'urql';
import { IOrganizer } from '@features/organizer/model/types';

export const GET_ORGANIZERS_QUERY = gql`
  query GetOrganizersByEventId($eventId: Int!) {
    getOrganizersByEventId(eventId: $eventId) {
      id
      email
      phone
      groupId
      firstName
      lastName
      active
    }
  }
`;

export interface GetOrganizersResponse {
  getOrganizersByEventId: IOrganizer[];
}

export const useGetOrganizers = (eventId: number | undefined, pause = false) => {
  const [result, reexecuteQuery] = useQuery<GetOrganizersResponse>({
    query: GET_ORGANIZERS_QUERY,
    variables: { eventId },
    pause: !eventId || pause,
    requestPolicy: 'network-only',
  });

  return {
    organizersList: result.data?.getOrganizersByEventId,
    fetching: result.fetching,
    error: result.error,
    refetch: reexecuteQuery,
  };
};
